import React from 'react';
import { Button, Text } from "@geist-ui/core";
import { useAuth } from '../../context/AuthContext';

const PatreonLoginButton = ({ className }) => {
  const { login } = useAuth();

  return (
    <Button 
      onClick={login}
      className={`theme-button theme-button--cta ${className || ''}`}
      style={{ 
        display: 'flex', 
        alignItems: 'center',
        backgroundColor: '#F96854', // Patreon color
        borderColor: '#F96854',
        color: 'white'
      }}
    >
      <img 
        src="/patreon-logo-white.svg" 
        alt="Patreon" 
        style={{ 
          width: '20px', 
          marginRight: '8px',
          display: 'inline-block',
          verticalAlign: 'middle' 
        }}
      />
      <Text span>Login with Patreon</Text>
    </Button>
  );
};

export default PatreonLoginButton; 